namespace advisorop.domains {
    "use strict";

    export interface IChartData {
        label?: string;
        value?: number;
        value2?: number;
        id?: number;
        idUniqueStr: string;
        cusip?: string;
        showValue?: string;
        bySecurityTypes?: any[];
        isProtective?: boolean;
        protectiveComposition?: IProtectiveComposition;
    }

    export interface IProtectiveComposition {
        assetClassId?: number;
        assetClass?: string;
        valueOfAssetClass?: number;
        valueOfGroup?: number;
        protectiveValue?: number;
        protectivePercentageOfAssetClass?: number;
        protectivePercentageOfGroup?: number;
        nonProtectiveValue?: number;
        nonProtectivePercentageOfAssetClass?: number;
        nonProtectivePercentageOfGroup?: number;
    }

    export interface IHistChartData {
        label?: string;
        value?: number;
        value2?: number;
        id?: number;
        showValue?: string;
        bySecurityTypes?: any[];
    }

    export interface IChartSettings {
        caption?: string;
        subCaption?: string;
        numberPrefix?: string;
        theme?: string;
        outCnvBaseFontSize?: string;
        placevaluesInside?: string;
        rotateValues?: string;
        showValues?: string;
        valueFontSize?: string;
        yAxisValuesStep?: string;
        valuePadding?: string;
        xAxisName?: string,
        yAxisName?: string,
    }

    export interface ChartCategoriesCategory {
        label?: string;
    }

    export interface IStackedBarChartCategories {
        category?: Array<ChartCategoriesCategory>;
    }

    export interface ChartDatasetData {
        value?: number;
        //percentageBasedValue?: number;
        //marketValueBasedValue?: number;
    }

    export interface IStackedBarChartDataset {
        seriesname?: string;
        renderas?: string;
        showvalues?: string;
        visible?: string;
        data?: Array<ChartDatasetData>;
    }

    export interface IChartDataSource {
        chart?: IChartSettings;
        data?: Array<IChartData>;
        categories?: Array<IStackedBarChartCategories>;
        dataset?: Array<IStackedBarChartDataset>;
        asOfDt?: Date;
        chartName?: string;
        chartId?: number;
        protectiveInstruments?: ISecurityNote[];
    }

    export interface IChartsDataSource {
        chartData?: Array<IChartDataSource>;
        histChartData?: Array<IChartDataSource>;
    }

    export interface IZoomlineChartSettings {
        caption?: string,
        subcaption?: string,
        yaxisname?: string,
        xaxisname?: string,
        forceaxislimits?: string,
        pixelsperpoint?: string,
        pixelsperlabel?: string,
        compactdatamode?: string,
        dataseparator?: string,
        theme?: string,
        numberScaleValue?: string,
        numberScaleUnit?: string,
        labelDisplay?: string,
        slantLabel?: string,
        useEllipsesWhenOverflow?: string,
        yAxisMaxValue?: string,
        yAxisMinValue?: string    }

    export interface IZoomlineChartDataSet {
        seriesname?: string;
        data?: string;
        initiallyHidden?: number;
    }

    export interface IZoomlineChartCategories {
        category?: string;
    }

    export interface IZoomlineChart {
        chart: IZoomlineChartSettings,
        categories: IZoomlineChartCategories[],
        dataset: IZoomlineChartDataSet[]
    }
}